import React from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { AccessibilityPopup } from '@skillz/accessibility';
import { deviceTypes } from "../../../enums/deviceTypes";
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import PageHeaderBar from "../pageHeaderBar/PageHeaderBar";
import classes from './Popup.module.css';

const Popup = ({ style, dropClass, dropClassClose, dropClassBody, close, children, dropClassContainer, accessibilityDescription, title, icon }) => {

    const { deviceType } = useSelector(state => state.responsive);
    const handleClose = (e) => {
        e && e.stopPropagation();
        close && close();
    };

    return createPortal(
        <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={handleClose}>
            <div className={`${classes.BackdropPopupContainer} ${dropClassContainer || ''}`}>
                <div className={`${classes.BackdropPopup} ${dropClass || ''}`} style={style}>
                    {close &&
                        <>
                            {deviceType === deviceTypes.mobile ?
                                <PageHeaderBar title={title} icon={icon} onBack={handleClose} className={classes.MobileHeader} />
                                :
                                <Icon size={"31px"} name={iconsList.x} color={"black"} className={`${classes.Close} ${classes.DesktopClose} ${dropClassClose || ''}`} onClick={handleClose} />
                            }
                        </>
                    }
                    <div className={`${classes.PopupBody} ${dropClassBody || ''}`}>
                        {children}
                    </div>
                </div>
            </div>
        </AccessibilityPopup>,
        document.body
    );
};

export default Popup;